import styled from 'styled-components/macro';
import React from 'react';
import {
  theme,
} from '../../../utilsClient/cssHelpers';
import Box, {
  propTypes,
  defaultProps,
} from './Box';

const Component = styled(Box)`
  background-color: ${theme('color.surface')};
  color: ${theme('color.onSurface')};
  border-color: ${theme('color.border')};
`;

const BoxPrimary = ({
  children,
  ...props
}) => {
  return <Component {...props}>{children}</Component>;
};

BoxPrimary.propTypes = propTypes;
BoxPrimary.defaultProps = defaultProps;

export default BoxPrimary;
